import {
  DttTeamViewPage,
  dttTeamViewPlugin,
} from '@cfa/dtt-teamview-backstage-plugin';
import {
  convertLegacyPageExtension,
  convertLegacyPlugin,
} from '@backstage/core-compat-api';

export const dttTeamviewPageModule = convertLegacyPlugin(
  dttTeamViewPlugin,
  {
    extensions: [
      convertLegacyPageExtension(DttTeamViewPage, {
        path: '/dtt-teamview',
        name: 'DTT Teamview',
      }),
    ],
  },
);